import React, { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Cotactus } from "../utils/Api";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Contactus = ({ meta, jsonLd }) => {

  const VALIDATION_PATTERN = {
    EMAIL: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [load, setLoad] = useState(false);



  const Submit = (data) => {
    setLoad(true);
    Cotactus(data)
      .then((res) => {
        if (res.data.status == 1) {
          setLoad(false);
          NotificationManager.success(res.data.message, "Success");
          reset();
        } else if (res.data.status == 0) {
          setLoad(false);
          NotificationManager.error(res.data.message, "Failed");
          reset();
        } else {
          setLoad(false);
          NotificationManager.error(res.data.message, "Failed");
          reset();
        }
      })
      .catch((err) => {
        reset();
        setLoad(false);
        NotificationManager.error("Some Error Occured", "Failed");
      });
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.scroll({
  //       top: 0,

  //       behavior: "smooth",
  //     });
  //   }, 100);
  // }, []);

//   const [address, setAddress] = useState(false);

//   const addressList =
//   {
//     landline: "+2302148500",
//     address: `Millance LTD,
// Office No. 4B,4th Floor, 
// The Docks 4, The Docks, Caudan, Port Louis, Mauritius.`,
//   }
//     ;

//   useEffect(() => {
//     const getCountry = async () => {
//       try {
//         const res = await fetch("https://ipapi.co/json/");
//         const data = await res.json();
//         const isEuropeOrAsia = data?.continent_code === "EU" || data?.continent_code === "AS";
//         setAddress(isEuropeOrAsia);
//       } catch (err) {
//         setAddress(false);
//       }
//     };
//     getCountry();
//   }, []);



  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <NotificationContainer />
      <div className="contact us">
        <section className="contact banner2">
          <div className="contactcont">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center mt-5">
                  <h1 className=" mb-2 mt-5">Contact Us</h1>
                  <p className=" mb-3">Let&apos;s Achieve Success Together!</p>
                </div>
                <div className="col-md-12 col-lg-6 mt-5">
                  <img
                    src={"/images/contact/contact22.png"}
                    alt="logo"
                    className="img-fluid mt-5"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="contact map mt-5">
          <div className="container">
            <div className="row">
              <div className="mapcontent text-center">
                <h2 className="mb-3">Contact Us</h2>
                <p>
                  We’re available 24/7 to assist you with any queries. Visit our FAQ page for quick answers and clear guidance, or reach out to our dedicated support team for personalized assistance anytime.
                </p>
              </div>
            </div>
          </div>
          <div className="mapform">
            <div className="container">
              <div className="row justify-content-center">

                <div className="col-sm-12 col-md-12 col-lg-6">
                  <div className="contact_form pt-2">
                    <form
                      action="/contact-us.php"
                      method="post"
                      onSubmit={handleSubmit(Submit)}
                    >
                      <div className="form-group">
                        <label className="gradient-text">Your Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          aria-describedby="emailHelp"
                          required=""
                          placeholder="Enter Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                            pattern: {
                              value: /^(?=.[a-zA-Z +\s])[a-zA-Z0-9].{1,30}$/i,
                              message: " Enter Valid  Name",
                            },
                          })}
                        />
                        <p className="text-danger">
                          {errors.name && (
                            <span role="alert">Name is required</span>
                          )}
                        </p>
                      </div>
                      <div className="form-group">
                        <label className="gradient-text">Your Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="name"
                          id="name"
                          aria-describedby="emailHelp"
                          required=""
                          placeholder="Enter Your Email Id"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required",
                            },
                            pattern: {
                              value: VALIDATION_PATTERN.EMAIL,
                              message: "Enter Valid Email",
                            },
                          })}
                        />
                        <p className="text-danger">
                          {errors.email && (
                            <span role="alert">Email is required</span>
                          )}
                        </p>
                      </div>
                      <div className="form-group">
                        <label className="gradient-text">
                          Your Phone Number
                        </label>
                        <input
                          type="phone"
                          className="form-control"
                          name="phone"
                          id="name"
                          aria-describedby="emailHelp"
                          required=""
                          placeholder="Enter Your Phone Number"
                          {...register("mobile_no", {
                            required: {
                              value: true,

                              message: "Please enter your phone number",
                            },
                            // pattern: {
                            //   value: /^[0-9\s]*$/,
                            //   maxLength: 6,
                            //   message: "Please enter min 6 phone number",
                            // },
                          })}
                          onKeyPress={(event) => {
                            if (
                              !/[0-9 ]+$/.test(event.key) ||
                              event.key === " "
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <p className="text-danger">
                          {errors.mobile_no && errors.mobile_no.message}
                        </p>
                      </div>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className={`form-check-input ${errors.checkbox ? "border-danger" : ""
                            }`}
                          id="existing_customer"
                          name="existing_customer"
                          {...register("subject", {
                            required: { value: true },
                          })}
                        />
                        <label
                          className={`form-check-label gradient-text ${errors.subject ? "text-danger" : ""
                            }`}
                          htmlFor="exampleCheck1"
                        >
                          Existing Customer{" "}
                          <span>( If Yes, please write your MT5 ID)</span>
                        </label>
                      </div>
                      <div className="form-group pt-3">
                        <label className="gradient-text">Comments</label>
                        <textarea
                          type="text"
                          name="comments"
                          id="comments"
                          required=""
                          className="form-control"
                          placeholder="Enter a comment"
                          defaultValue={""}
                          {...register("msg", {
                            required: {
                              value: true,
                              message: "Please enter a comment",
                            },
                          })}
                        />
                        <p className="text-danger">
                          {errors.msg && (
                            <span role="alert">Please enter a comment</span>
                          )}
                        </p>
                      </div>
                      {load ? (
                        <>
                          {" "}
                          <div className="button ">
                            <button
                              type="button"
                              name="submit"
                              className="btn more-btn"
                            >
                              Loading...
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          {" "}
                          <div className="button ">
                            <button
                              type="submit"
                              name="submit"
                              className="btn more-btn"
                            >
                              Send Message
                            </button>
                          </div>
                        </>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ourteam support mt-5">
          <div className="container">
            <div className="row">
              <div className="team text-center">
                <h2 className="mb-3"> 24/7 Dedicated Support – Always Here for You!</h2>
                <p>
                  Our expert support team is available around the clock, ensuring prompt assistance whenever you need it.                </p>
              </div>
            </div>
            <Carousels
              swipeable={false}
              draggable={false}
              showDots={false}
              responsive={responsive}
              autoPlay={true}
              ssr={true} // means to render carousel on server-side.
              infinite={true}
              autoPlaySpeed={1500}
              keyBoardControl={true}
              className="slider1 mt-5"
              slidesToShow={1}
              slidesToScroll={1}
              transitionDuration={500}
              containerClass="carousel-container"
              removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
              dotListClass="custom-dot-list-style"
              itemClass="carousel-item-padding-40-px"
            >
              <div className="contactsli1">
                <img
                  src={"/images/contact/support1.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>

              <div className="contactsli2">
                <img
                  src={"/images/contact/support3.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="contactsli3">
                <img
                  src={"/images/contact/support4.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="contactsli4">
                <img
                  src={"/images/contact/support5.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="contactsli5">
                <img
                  src={"/images/contact/support6.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
              <div className="contactsli6">
                <img
                  src={"/images/contact/support7.png"}
                  alt="logo"
                  className="img-fluid"
                />
              </div>
            </Carousels>
          </div>
        </div>
        <section className="contactvantage mt-5">
          <div className="container">
            <div className="contact_us_row1">
              <div className="inner">
                <h2 className="mb-3">Get in Touch with Millance</h2>
                <p className="contconpara">
                  Have questions or need more information? Reach out to us through any of the contact methods below. Our team is available 24/7 to assist you.
                </p>
                <div className="contactmillance mt-4">
                  <div className="row m-auto">
                    <div className="col-lg-3 col-sm-12 col-md-12 mt-3 mb-4">
                      <div className="text_box">
                        <img
                          src={"/images/contact/msg.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                        <a href="mailto:support@millance.com" target="_blank" style={{ color: "inherit" }}>
                          Email Support
                        </a>
                        {/* {!!country && country !== "IN" ? <p className="mt-2" style={{ color: "inherit", 'fontWeight': 'bold' }}>
                          India: +91 96299 47607<br />
                          0427-2440458
                        </p> : <></>} */}
                        <p className="mt-3">
                          Reach out to us at <b><a href="mailto:support@millance.com" target="_blank" style={{ color: "inherit" }}>
                            support@millance.com
                          </a></b>, and our team will respond within 24 hours. If you&apos;re an existing client, please include your account number and support PIN for faster assistance.
                        </p>
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-12 col-md-12 mt-3 mb-4">
                      <div className="text_box">
                        <img
                          src={"/images/contact/address.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                        <a>Registered Address</a>
                        <p className="mt-3" >

                          PO Box 1212, HAMCHAKO, MUTSAMUDU. THE AUTONOMOUS ISLAND OF ANJOUAN, UNION OF COMOROS.  <br />
                          <span className="fw-bolder">Registration Number - 15996</span>
                        </p>


                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-12 col-md-12 mt-3 mb-4">
                      <div className="text_box">
                        <img
                          src={"/images/aboutus/corporate.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                        <a>Physical Address</a>


                        {/* <p>
                          <br />152 Al Mansoori,
                          Hor Al Anz, Dubai,
                          <br />United Arab Emirates.
                          <br />
                        </p> */}



                        <p className="mt-2">
                          Millance LTD, Office No. 4B,4th Floor, The Docks 4, The Docks, Caudan, Port Louis, Mauritius.
                          {/* {
                            address ? addressList.address : ''
                          } */}

                        </p>


                        <p>

                            <span className="fw-bolder mt-2">Landline - +2302148500</span>
                        </p>
                        {/* <p className="mt-2">
                          <a> Address</a>
                          <br />
                          Millance Star Technologies L.L.C,<br />
                          301-3, 3rd Floor, Sultan Business Center Building,<br /> Oud Metha, Dubai, United Arab Emirates.
                        </p> */}

                        {/* {!!country && country != "IN" ?
                          <>
                            <p className="mt-3" >

                              PO Box 1212, HAMCHAKO, MUTSAMUDU. THE AUTONOMOUS ISLAND OF ANJOUAN, UNION OF COMOROS,  <br />
                              <span className="fw-bolder">Registration Number - 15996</span>,
                            </p>
                            <p className="mt-2">
                              <a>Physical Address</a>
                              <br /> Kandhaswarna Mega Mall, 2nd  Floor,
                              <br />Saradha College Road, Hastampatty, Salem – 636016
                              <br />TamilNadu, India.
                            </p>
                          </> :
                          <>
                            <p>
                              {" "}
                              Millance Ltd, <br />
                            </p>
                            <p className="mt-1">
                              PO Box 1212, HAMCHAKO, MUTSAMUDU. THE AUTONOMOUS ISLAND OF ANJOUAN, UNION OF COMOROS <br /> <span className="fw-bolder">Registration Number - 15996</span></p>

                          </>

                        } */}
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-12 col-md-12 mt-3 mb-4">
                      <div className="text_box">
                        <img
                          src={"/images/contact/chat.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                        <a>Live Chat</a>
                        <p className="mt-3">
                          Need immediate assistance? Connect with our support team via live chat. If you&apos;re an existing client, kindly provide your account number for a quicker resolution.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="contact get-ready mt-5">
  <div className="container">
    <h2>Get Ready</h2>
    <div className="ready-buttons justify-content-center">
<button type="button" className="btn btn-g-ready">button 1</button>
<button type="button" className="btn btn-g-ready">button 2</button>
<button type="button" className="btn btn-g-ready">button 3</button>
<button type="button" className="btn btn-g-ready">button 4</button>
    </div>
  </div>
</section> */}
      </div>
    </>
  );
};

export default Contactus;
